import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/start',
    name: 'start',
    component: () => import('@/views/Start.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/About.vue')
  },
  {
    path: '/alltypings',
    name: 'alltypings',
    component: () => import('@/views/AllTypings.vue')
  },
  {
    path: '/top100',
    name: 'top100',
    component: () => import('@/views/Top100.vue')
  },
  // {
  //   path: '/addtyping',
  //   name: 'addtyping',
  //   component: () => import('@/views/AddTyping.vue')
  // },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
